// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"fb52dbe3ba5ef321b049","151":"55e47d5e2d624e6050ed","307":"d5fd28fb5687d11cb877"}[chunkId] + ".js";
};